// Mock data for The House of Renovation and Design
// Rugged, construction-focused content

export const companyInfo = {
  name: "The House of Renovation and Design",
  tagline: "Built Right. Built to Last.",
  description: "Quality craftsmanship and honest work in Halifax & HRM",
  phone: "(902) 333-7144",
  // email: "info@houseofreno.ca",
  email: "thehouse.rd@outlook.com",
  address: "Halifax, Nova Scotia",
  serviceArea: "Halifax & HRM",
  social: {
    facebook: "https://www.facebook.com/house.reno.design",
    instagram: "https://www.instagram.com/house.reno.design",
  },
};

export const services = [
  {
    id: 1,
    name: "Kitchen Renovations",
    description: "Complete tear-outs to custom builds. Cabinets, countertops, backsplash — done right.",
    icon: "Hammer",
  },
  {
    id: 2,
    name: "Flooring",
    description: "Hardwood, tile, vinyl. Proper subfloor prep. Seamless installs that last decades.",
    icon: "Layers",
  },
  {
    id: 3,
    name: "Drywall & Finishing",
    description: "Level 5 finishes, repairs, texture matching. Clean lines, no shortcuts.",
    icon: "Wrench",
  },
  {
    id: 4,
    name: "Wallpaper",
    description: "Professional installation. Accent walls to full rooms. Precise pattern matching.",
    icon: "Paintbrush",
  },
  {
    id: 5,
    name: "Full Renovations",
    description: "Gut jobs to complete transformations. We handle it all — start to finish.",
    icon: "HardHat",
  },
];

export const projects = [
  {
    id: 1,
    title: "Bathroom Gut & Modern Rebuild",
    category: "Full Renovations",
    description: "Full bathroom renovation",
    coverImage: "/images/Full Renovations/1.0.jpg",
    location: "Dartmouth, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/1.1.jpg",
        caption: "Bathroom before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/1.0.jpg",
        caption: "Completed modern bathroom",
      },
    ],
  },
  {
    id: 2,
    title: "Backyard Pergola Build",
    category: "Decking",
    description: "Custom backyard pergola structure",
    coverImage: "/images/Decking/1.0.jpg",
    location: "Eastern Passage, NS",
    media: [
      {
        type: "image",
        url: "/images/Decking/1.0.jpg",
        caption: "Completed backyard pergola structure",
      },
      {
        type: "video",
        url: "/images/Decking/1.1.mp4",
        caption: "Pergola construction video overview",
      },
    ],
  },
  {
    id: 3,
    title: "Hardwood Flooring Installation",
    category: "Flooring",
    description: "Hardwood flooring install",
    coverImage: "/images/Flooring/2.1.jpg",
    location: "Dartmouth, NS",
    media: [
      {
        type: "image",
        url: "/images/Flooring/2.0.jpg",
        caption: "Old flooring",
      },
      {
        type: "image",
        url: "/images/Flooring/2.1.jpg",
        caption: "After hardwood flooring installation",
      },
      {
        type: "video",
        url: "/images/Flooring/2.3.mp4",
        caption: "Flooring installation walkthrough",
      },
    ],
  },
  {
    id: 4,
    title: "Kitchen Refresh & Flooring Update",
    category: "Full Renovations",
    description: "Kitchen refresh renovation",
    coverImage: "/images/Full Renovations/3.3.jpg",
    location: "Dartmouth, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/3.0.jpg",
        caption: "Kitchen before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/3.1.jpg",
        caption: "Kitchen after renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/3.2.jpg",
        caption: "Kitchen before renovation - alternate angle",
      },
      {
        type: "image",
        url: "/images/Full Renovations/3.3.jpg",
        caption: "Kitchen after renovation - alternate angle",
      },
      {
        type: "video",
        url: "/images/Full Renovations/3.4.mp4",
        caption: "Kitchen transformation video",
      },
    ],
  },
  {
    id: 5,
    title: "Bathroom Vanity & Fixture Upgrade",
    category: "Full Renovations",
    description: "Modern bathroom upgrade",
    coverImage: "/images/Full Renovations/2.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/2.1.jpg",
        caption: "Bathroom vanity before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/2.0.jpg",
        caption: "Updated vanity, mirror, and fixtures",
      },
    ],
  },
  {
    id: 6,
    title: "Kitchen Gut & Modern Rebuild",
    category: "Full Renovations",
    description: "Full kitchen renovation",
    coverImage: "/images/Full Renovations/4.0.jpg",
    location: "Eastern Passage, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/4.1.jpg",
        caption: "Kitchen before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/4.0.jpg",
        caption: "Completed modern kitchen",
      },
    ],
  },
  {
    id: 7,
    title: "Open-Concept Kitchen Renovation",
    category: "Full Renovations",
    description: "Open-concept kitchen remodel",
    coverImage: "/images/Full Renovations/5.1.png",
    location: "Clayton Park, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/5.0.jpg",
        caption: "Before kitchen renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/5.1.png",
        caption: "After completing open-concept kitchen - main angle",
      },
      {
        type: "image",
        url: "/images/Full Renovations/5.2.jpg",
        caption: "After completing open-concept kitchen - alternate angle",
      },
      {
        type: "video",
        url: "/images/Full Renovations/5.3.mp4",
        caption: "Completed open-concept kitchen renovation video",
      },
    ],
  },
  {
    id: 8,
    title: "Open-Concept Kitchen Redesign",
    category: "Full Renovations",
    description: "Full kitchen redesign",
    coverImage: "/images/Full Renovations/6.0.jpg",
    location: "Whites Lake, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/6.2.jpg",
        caption: "Kitchen before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/6.1.jpg",
        caption: "Kitchen design and layout planning",
      },
      {
        type: "image",
        url: "/images/Full Renovations/6.0.jpg",
        caption: "Completed open-concept kitchen",
      },
    ],
  },
  {
    id: 9,
    title: "Full Interior Finish & Flooring",
    category: "Full Renovations",
    description: "Interior finish renovation",
    coverImage: "/images/Full Renovations/7.1.jpg",
    location: "Dartmouth, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/7.1.jpg",
        caption: "After interior finish and flooring",
      },
      {
        type: "video",
        url: "/images/Full Renovations/7.0.mp4",
        caption: "Drywall, trim, and flooring renovation",
      },
    ],
  },
  {
    id: 10,
    title: "Modern Kitchen Renovation",
    category: "Full Renovations",
    description: "Modern kitchen renovation",
    coverImage: "/images/Full Renovations/8.3.jpg",
    location: "Eastern Passage, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/8.0.jpg",
        caption: "Before kitchen renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/8.1.jpg",
        caption: "Another angle from before kitchen renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/8.2.jpg",
        caption: "A third angle from before kitchen renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/8.3.jpg",
        caption: "After kitchen renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/8.4.jpg",
        caption: "After kitchen renovation - wide angle",
      },
      {
        type: "video",
        url: "/images/Full Renovations/8.5.mp4",
        caption: "Completed modern kitchen renovation",
      },
    ],
  },
  {
    id: 11,
    title: "Full Bathroom Renovation",
    category: "Full Renovations",
    description: "Complete bathroom remodel",
    coverImage: "/images/Full Renovations/9.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/9.1.jpg",
        caption: "Bathroom before renovation",
      },
      {
        type: "image",
        url: "/images/Full Renovations/9.0.jpg",
        caption: "Completed bathroom renovation",
      },
    ],
  },
  {
    id: 12,
    title: "Custom Kitchen Renovation with Island",
    category: "Full Renovations",
    description: "Custom kitchen renovation",
    coverImage: "/images/Full Renovations/10.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Full Renovations/10.0.jpg",
        caption: "Completed custom kitchen renovation",
      },
      {
        type: "video",
        url: "/images/Full Renovations/10.1.mp4",
        caption: "Kitchen renovation walkthrough",
      },
    ],
  },
  {
    id: 13,
    title: "Pattern Tile Flooring Installation",
    category: "Flooring",
    description: "Custom tile flooring",
    coverImage: "/images/Flooring/1.0.jpg",
    location: "Prospect, NS",
    media: [
      {
        type: "image",
        url: "/images/Flooring/1.1.jpg",
        caption: "Space before flooring installation",
      },
      {
        type: "image",
        url: "/images/Flooring/1.0.jpg",
        caption: "Completed patterned tile flooring",
      },
      {
        type: "video",
        url: "/images/Flooring/1.2.mp4",
        caption: "Flooring installation walkthrough",
      },
    ],
  },
  {
    id: 14,
    title: "Basement Flooring Installation",
    category: "Flooring",
    description: "Basement flooring install",
    coverImage: "/images/Flooring/3.1.jpg",
    location: "Dartmouth, NS",
    media: [
      {
        type: "image",
        url: "/images/Flooring/3.1.jpg",
        caption: "Completed basement flooring installation",
      },
      {
        type: "video",
        url: "/images/Flooring/3.0.mp4",
        caption: "Flooring installation walkthrough",
      },
    ],
  },
  {
    id: 15,
    title: "Upstairs Flooring Installation",
    category: "Flooring",
    description: "Upstairs flooring install",
    coverImage: "/images/Flooring/4.3.png",
    location: "Clayton Park, NS",
    media: [
      {
        type: "video",
        url: "/images/Flooring/4.0.mp4",
        caption: "Old upstairs flooring before installation",
      },
      {
        type: "video",
        url: "/images/Flooring/4.1.mp4",
        caption: "Installation walkthrough for upstairs flooring",
      },
    ],
  },
  {
    id: 16,
    title: "Living Room Feature Wallpaper",
    category: "Wallpaper",
    description: "Large living room wallpaper feature",
    coverImage: "/images/Wallpaper/4.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/4.0.jpg",
        caption: "Living room wallpaper feature wall",
      },
      {
        type: "image",
        url: "/images/Wallpaper/4.1.jpg",
        caption: "Alternate angle of wallpaper installation",
      },
    ],
  },
  {
    id: 17,
    title: "Bathroom Wallpaper Upgrade",
    category: "Wallpaper",
    description: "Custom wallpaper install",
    coverImage: "/images/Wallpaper/1.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/1.1.jpg",
        caption: "Bathroom before wallpaper installation",
      },
      {
        type: "image",
        url: "/images/Wallpaper/1.0.jpg",
        caption: "Completed wallpaper feature wall",
      },
    ],
  },
  {
    id: 18,
    title: "Bathroom Wallpaper Feature",
    category: "Wallpaper",
    description: "Wallpaper feature wall",
    coverImage: "/images/Wallpaper/2.1.jpg",
    location: "Peggy's Cove, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/2.0.jpg",
        caption: "Preparation for bathroom wallpaper installation",
      },
      {
        type: "image",
        url: "/images/Wallpaper/2.1.jpg",
        caption: "Completed wallpaper feature bathroom",
      },
      {
        type: "video",
        url: "/images/Wallpaper/2.2.mp4",
        caption: "Bathroom before wallpaper installation",
      },
    ],
  },
  {
    id: 19,
    title: "Bathtub Wallpaper Accent",
    category: "Wallpaper",
    description: "Wallpaper accent behind bathtub",
    coverImage: "/images/Wallpaper/3.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/3.0.jpg",
        caption: "Completed bathtub wallpaper feature",
      },
      {
        type: "image",
        url: "/images/Wallpaper/3.1.jpg",
        caption: "Bathroom before wallpaper installation",
      },
    ],
  },
  {
    id: 20,
    title: "Living Space Wallpaper Feature",
    category: "Wallpaper",
    description: "Wallpaper feature in living space",
    coverImage: "/images/Wallpaper/5.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/5.0.jpg",
        caption: "Completed living space wallpaper installation",
      },
      {
        type: "image",
        url: "/images/Wallpaper/5.1.jpg",
        caption: "Living space before wallpaper installation",
      },
    ],
  },
  {
    id: 21,
    title: "Custom Living Room Media Wall",
    category: "Custom Projects",
    description: "Custom-built living room media wall with floating shelves and integrated fireplace",
    coverImage: "/images/Custom/2.0.jpg",
    location: "Whites Lake, NS",
    media: [
      {
        type: "image",
        url: "/images/Custom/2.0.jpg",
        caption: "Completed custom media wall with shelving and fireplace",
      },
      {
        type: "image",
        url: "/images/Custom/2.1.jpg",
        caption: "Living room before custom media wall installation",
      },
    ],
  },
  {
    id: 22,
    title: "Custom Outdoor Trash Enclosure",
    category: "Custom Projects",
    description: "Custom-built wooden enclosure designed to conceal outdoor trash and recycling bins",
    coverImage: "/images/Custom/3.0.jpg",
    location: "Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Custom/3.0.jpg",
        caption: "Completed custom wooden trash bin enclosure",
      },
      {
        type: "image",
        url: "/images/Custom/3.1.jpg",
        caption: "Completed custom wooden trash bin enclosure",
      },
      {
        type: "image",
        url: "/images/Custom/3.2.jpg",
        caption: "Completed custom wooden trash bin enclosure",
      },
      {
        type: "video",
        url: "/images/Custom/3.3.mp4",
        caption: "Custom trash enclosure build overview",
      },
    ],
  },
  {
    id: 23,
    title: "Custom Rope Railing",
    category: "Custom Projects",
    description: "Custom rope railing installed along staircase for a functional and decorative interior accent",
    coverImage: "/images/Custom/4.0.jpg",
    location: "Terence Bay, NS",
    media: [
      {
        type: "image",
        url: "/images/Custom/4.0.jpg",
        caption: "Completed custom rope railing installation",
      },
      {
        type: "image",
        url: "/images/Custom/4.1.jpg",
        caption: "Completed custom rope railing installation",
      },
    ],
  },
  {
    id: 24,
    title: "Full Basement Flooring",
    category: "Flooring",
    description: "Completed a full basement flooring installation in Sackville, NS",
    coverImage: "/images/Flooring/5.3.jpg",
    location: "Sackville, NS",
    media: [
      {
        type: "image",
        url: "/images/Flooring/5.0.jpg",
        caption: "Before basement flooring installation",
      },
      {
        type: "image",
        url: "/images/Flooring/5.1.jpg",
        caption: "After basement flooring installation",
      },
      {
        type: "image",
        url: "/images/Flooring/5.2.jpg",
        caption: "Before basement flooring installation - alternate angle",
      },
      {
        type: "image",
        url: "/images/Flooring/5.3.jpg",
        caption: "After basement flooring installation - another angle",
      },
    ],
  },
  {
    id: 25,
    title: "Seabright Basement Renovation",
    category: "Flooring",
    description: "Completed a full basement flooring installation in Seabright, NS",
    coverImage: "/images/Flooring/6.1.png",
    location: "Seabright, NS",
    media: [
      {
        type: "image",
        url: "/images/Flooring/6.0.jpg",
        caption: "After basement flooring installation",
      },
      {
        type: "image",
        url: "/images/Flooring/6.1.png",
        caption: "Before basement flooring installation - alternate angle",
      },
      {
        type: "video",
        url: "/images/Flooring/6.2.mp4",
        caption: "Walkthrough of completed basement flooring installation",
      },
    ],
  },
  {
    id: 26,
    title: "Full Bathroom Wallpaper",
    category: "Wallpaper",
    description: "Full bathroom wallpaper installation",
    coverImage: "/images/Wallpaper/6.1.jpg",
    location: "Clayton Park, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/6.0.jpg",
        caption: "Before wallpaper installation",
      },
      {
        type: "image",
        url: "/images/Wallpaper/6.1.jpg",
        caption: "After wallpaper installation",
      },
    ],
  },
  {
    id: 27,
    title: "Downtown Hotel Wallpaper Installation",
    category: "Wallpaper",
    description: "Professional wallpaper installation for the Lord Nelson downtown hotel",
    coverImage: "/images/Wallpaper/7.2.jpg",
    location: "Downtown Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/7.0.jpg",
        caption: "Hallway before wallpaper installation",
      },
      {
        type: "image",
        url: "/images/Wallpaper/7.1.jpg",
        caption: "After the wallpaper installation in the hallway",
      },
      {
        type: "image",
        url: "/images/Wallpaper/7.2.jpg",
        caption: "Wallpaper installation in the hotel lobby",
      },
      {
        type: "image",
        url: "/images/Wallpaper/7.3.jpg",
        caption: "Another angle of the wallpaper",
      },
    ],
  },
  {
    id: 28,
    title: "Bathroom Wallpaper Installation",
    category: "Wallpaper",
    description: "Bathroom wallpaper installation",
    coverImage: "/images/Wallpaper/8.1.jpg",
    location: "Downtown Halifax, NS",
    media: [
      {
        type: "image",
        url: "/images/Wallpaper/8.0.jpg",
        caption: "Before",
      },
      {
        type: "image",
        url: "/images/Wallpaper/8.1.jpg",
        caption: "After",
      },
    ],
  },
  {
    id: 29,
    title: "Backyard Deck Extension",
    category: "Decking",
    description: "A custom backyard deck extension",
    coverImage: "/images/Decking/2.1.jpg",
    location: "Lower Sackville, NS",
    media: [
      {
        type: "image",
        url: "/images/Decking/2.0.jpg",
        caption: "Process of building the deck extension",
      },
      {
        type: "image",
        url: "/images/Decking/2.1.jpg",
        caption: "Completed backyard deck extension",
      },
      {
        type: "image",
        url: "/images/Decking/2.2.jpg",
        caption: "Completed backyard deck extension - alternate angle",
      },
    ],
  },
  {
    id: 30,
    title: "Custom Deck Renovation",
    category: "Decking",
    description: "A custom backyard deck renovation",
    coverImage: "/images/Decking/3.3.jpg",
    location: "Prospect, NS",
    media: [
      {
        type: "image",
        url: "/images/Decking/3.0.jpg",
        caption: "",
      },
      {
        type: "image",
        url: "/images/Decking/3.1.jpg",
        caption: "",
      },
      {
        type: "image",
        url: "/images/Decking/3.2.jpg",
        caption: "",
      },
      {
        type: "image",
        url: "/images/Decking/3.3.jpg",
        caption: "",
      },
    ],
  },
  {
    id: 31,
    title: "Custom Outdoor Trash Enclosure",
    category: "Custom Projects",
    description: "Custom-built wooden enclosure designed to conceal outdoor trash and recycling bins",
    coverImage: "/images/Custom/5.0.jpg",
    location: "Prospect, NS",
    media: [
      {
        type: "image",
        url: "/images/Custom/5.0.jpg",
        caption: "Completed custom wooden trash bin enclosure",
      },
      {
        type: "image",
        url: "/images/Custom/5.1.jpg",
        caption: "Completed custom wooden trash bin enclosure",
      },
    ],
  },
  {
    id: 32,
    title: "Custom Wine Barrel",
    category: "Custom Projects",
    description: "Custom-built wooden enclosure designed to carry beverages and alcohol",
    coverImage: "/images/Custom/6.2.jpg",
    location: "Prospect, NS",
    media: [
      {
        type: "image",
        url: "/images/Custom/6.0.jpg",
        caption: "How it started...",
      },
      {
        type: "image",
        url: "/images/Custom/6.1.jpg",
        caption: "How it's going...",
      },
      {
        type: "image",
        url: "/images/Custom/6.2.jpg",
        caption: "Completed custom wine barrel",
      },
    ],
  },
  {
    id: 33,
    title: "Custom Wine Barrel",
    category: "Custom Projects",
    description: "Another custom-built wooden enclosure for beverages and alcohol",
    coverImage: "/images/Custom/7.1.PNG",
    location: "Lebanon",
    media: [
      {
        type: "image",
        url: "/images/Custom/7.0.PNG",
        caption: "",
      },
      {
        type: "image",
        url: "/images/Custom/7.1.PNG",
        caption: "",
      },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Mike & Sarah T.",
    location: "Halifax, NS",
    rating: 5,
    text: "Angelo's crew showed up on time every day. Kitchen came out better than we imagined. These guys know what they're doing.",
    project: "Kitchen Renovation",
  },
  {
    id: 2,
    name: "Dan Robertson",
    location: "Bedford, NS",
    rating: 5,
    text: "Had three quotes. Angelo was straight up about what the job needed. No surprises, fair price, solid work.",
    project: "Flooring Installation",
  },
  {
    id: 3,
    name: "The Hendersons",
    location: "Dartmouth, NS",
    rating: 5,
    text: "Our basement was a disaster. Now it's the best room in the house. Real craftsmanship, clean job site, no excuses.",
    project: "Basement Finishing",
  },
];

export const founder = {
  name: "Angelo Farah",
  title: "Founder & Lead Contractor",
  image: "/images/Angelo/Aneglo.jpg",
  story: [
    "The House of Renovation and Design is a full-service renovation and finishing company dedicated to transforming homes into beautiful, functional spaces that reflect your lifestyle. We specialize in interior renovations, professional wallpaper installation, custom woodwork, and detailed finishing, delivering craftsmanship you can see and quality you can trust.",

    "Whether you’re updating a single room or planning a full home makeover, our team focuses on precision, clean workmanship, and reliable service from start to finish. We combine construction expertise with an artistic eye to create feature walls, custom details, and tailored designs that make every project unique, whether it be residential or commercial.",

    "We understand that inviting contractors into your home requires trust. That’s why we prioritize clear communication, respect for your space, and dependable timelines. Our goal is to make the renovation process smooth, stress-free, and rewarding.",

    "We take pride in delivering results that not only look exceptional but also stand the test of time. At House of Reno, your home isn’t just another project, it’s a space we help bring to life.",
  ],
  values: [
    "Interior home renovations",
    "Professional wallpaper installation",
    "Custom woodwork and drywall installation",
    "Trim, finishing, and decorative upgrades",
    "Home Repairs, flooring, and more",
  ],
};

export const stats = [
  { number: "150+", label: "Projects Completed" },
  { number: "10+", label: "Years Experience" },
  { number: "100%", label: "Job Completion Rate" },
  { number: "0", label: "Shortcuts Taken" },
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Projects", path: "/projects" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];
